import React from 'react';

export type BadgeProps = {
    color?:
        | 'primary'
        | 'secondary'
        | 'success'
        | 'danger'
        | 'warning'
        | 'info'
        | 'light'
        | 'dark';
    className?: string;
    children;
};

const classMapping = {
    primary: 'badge-primary',
    secondary: 'badge-secondary',
    success: 'badge-success',
    danger: 'badge-danger',
    warning: 'badge-warning',
    info: 'badge-info',
    light: 'badge-light',
    dark: 'badge-dark'
};

const Badge = ({
    color = 'primary',
    className,
    children,
    ...props
}: BadgeProps) => {
    let rootClass = `badge ${classMapping[color]} ${className ?? ''}`;
    rootClass += ['light'].includes(color) ? ' text-dark' : '';

    return (
        <span {...props} className={rootClass}>
            {children}
        </span>
    );
};

export default Badge;
